module.exports = __webpack_public_path__ + "8ce2b6bc.webp";